import React from 'react';
import store from '../store';
import axios from 'axios';
import { setClientSettings} from "actions";
import tsl from 'app/tsl';
import moment from 'moment-timezone';

export const getSettings = (key = null, defaultValue = null) => {
  const s = store.getState().settings.clientSettings;

  if (s) {
    if (key) {
      return s[key] !== undefined ? s[key] : defaultValue;
    }

    return s;
  } else if (key === null) {
    return {};
  }

  return null;
};

export const loadSettings = () => {
  return axios.get('/api/operator/settings').then((response) => {
    const settings = response.data;

    // Set moment locale based on the ampm setting
    if (settings.ampm) {
      moment.locale('en-US');
    } else {
      moment.locale('en-GB');
    }
    // Set the global moment timezone if it's provided in the settings
    if (settings.timezone) {
      moment.tz.setDefault(settings.timezone);
    }

    store.dispatch(setClientSettings(response.data));
  });
};

export const getWeightUnit = () => {
  const weight_unit = getSettings().weight_unit;

  return tsl(`unit.${weight_unit}`);
};


// WEBPACK FOOTER //
// ./utils/client.js